//load Fennec analytics script

import { getDefaultConfig } from 'Utils/Store';

export function loadFennec() {
  const src = getDefaultConfig('fennec');
  const script = document.createElement('script');
  script.src = src;
  document.getElementsByTagName('head')[0].appendChild(script);
  script.onload = () => {
    const fennecInstance = new window.Fennec('nation');
    fennecInstance.initFennec();
  };
}
